import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from '../admin-available-modals';

@Component({
    selector: 'app-confirm-remove-user-admin',
    templateUrl: './confirm-remove-user-admin.component.html',
    standalone: false
})
export class ConfirmRemoveUserAdminComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('confirmRemoveUserAdmin', { static: true }) public modalView: ModalDirective;

  ngAfterViewInit() {
    this.modalId = AdminAvailableModals.CONFIRM_REMOVE_USER_ADMIN;
    this.modalView.show();
  }

  public returnType(obj) {
    return typeof obj;
  }
}
